<template>
  <main>
    <vue-headful
      title="ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises"
      description="L'ADLCJ gère l'école complémentaire pour l'enseignement du japonais à Lyon, et propose également des cours de japonais pour adultes."
      url="https://adlcj.fr/adlcj"
      image="https://adlcj.fr/img/logo.a4b45b1d.jpg"
      type="profile"
      site_name="ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises"
    />
    <div class="title">
      <div class="title-wrapper">
        <h1>ADLCJ</h1>
      </div>
      <p>
        Association pour le Développement de la Langue et de la Culture
        Japonaises
      </p>
    </div>
    <div v-if="this.$i18n.locale === 'ja'">
      <AdlcjJA />
    </div>
    <div v-if="this.$i18n.locale === 'fr'">
      <AdlcjFR />
    </div>
  </main>
</template>

<script>
import AdlcjJA from "../components/AdlcjJA.vue";
import AdlcjFR from "../components/AdlcjFR.vue";
export default {
  components: {
    AdlcjJA,
    AdlcjFR,
  },
};
</script>

<style lang="scss" scoped>

.adlcj {
  line-height: 1.75;
}
</style>